import { Stack } from '@mui/material';

import { SearchTextBox } from './searchTextBox';

import { AddButton } from '../buttons/addButton';

export const SearchBar = ({
  value,
  setValue,
  placeholder,
  selectedValues,
  onAddClick,
  showAddButton,
  hideSearchIcon,
}: {
  value: string;
  setValue: (value: string) => void;
  placeholder: string;
  selectedValues: string[];
  onAddClick?: (value: string[]) => void;
  showAddButton: boolean;
  hideSearchIcon?: boolean;
}) => {
  const addCallback = () => {
    if (showAddButton && onAddClick) {
      const values = [...selectedValues, value];
      onAddClick(values);
      setValue('');
    }
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      paddingY='12px'
      gap='12px'
      className='w-full'
    >
      <SearchTextBox
        value={value}
        onChange={setValue}
        placeholder={placeholder}
        sx={{ flexGrow: 1 }}
        hideIcon={hideSearchIcon}
        onEnter={showAddButton && onAddClick ? addCallback : undefined}
      />
      {showAddButton && onAddClick && (
        <AddButton
          disabled={selectedValues.includes(value) || !value}
          onClick={addCallback}
        />
      )}
    </Stack>
  );
};
